export default __webpack_public_path__ + "static/media/learose2-1920w.23c4c0a5.png";